(ns practitest.frontend.components.project-assistant.schema
  (:require
    [practitest.frontend.common.re-frame :as rf-common]))

;; ---- schema ----

(def UserMessageSchema
  [:map
   [:role [:= "user"]]
   [:content :string]
   [:position {:optional true} int?]
   [:id {:optional true} pos-int?]
   [:context-entity {:optional true} [:maybe :string]]])

(def AssistantMessageSchema
  [:map
   [:role [:= "assistant"]]
   [:content :string]
   [:position {:optional true} int?]
   [:id {:optional true} pos-int?]])

(def ToolCallMessageSchema
  [:map
   [:role [:= "tool-call"]]
   [:content :string]])

(def PendingActionMessageSchema
  [:map
   [:role [:= "pending-action"]]
   [:tool-call-id :string]
   [:tool-name :string]
   [:args :map]
   [:status [:enum :pending :confirmed :dismissed :failed]]
   [:result {:optional true} [:maybe :string]]
   [:position {:optional true} int?]
   [:id {:optional true} pos-int?]])

(def MessageSchema
  [:multi {:dispatch :role}
   ["user" UserMessageSchema]
   ["assistant" AssistantMessageSchema]
   ["tool-call" ToolCallMessageSchema]
   ["pending-action" PendingActionMessageSchema]])

(def ConversationSchema
  [:map
   [:id pos-int?]
   [:title {:optional true} [:maybe :string]]
   [:model {:optional true} :string]
   [:created_at {:optional true} :string]
   [:updated_at {:optional true} :string]
   [:last_message_at {:optional true} [:maybe :string]]])

(def BudgetSchema
  [:map
   [:status {:optional true} :string] ;; "ok", "soft_limit", "hard_limit"
   [:used_cents {:optional true} number?]
   [:budget_cents {:optional true} number?]])

(def RenameStateSchema
  [:map
   [:id pos-int?]
   [:draft :string]])

(def ActivePtqlSchema
  [:map
   [:entity keyword?]
   [:query :string]])

(def ProjectAssistantSchema
  [:map {:closed true}
   [:panel-open? {:optional true} :boolean]
   [:active-tab {:optional true} [:enum :chat :history]]
   [:connected? {:optional true} :boolean]
   [:streaming? {:optional true} :boolean]
   [:error {:optional true} [:maybe :string]]
   [:token {:optional true} :string]
   [:next-position {:optional true} int?]
   [:conversation {:optional true} [:maybe ConversationSchema]]
   [:messages {:optional true} [:vector MessageSchema]]
   [:pending-actions-buffer {:optional true} [:vector MessageSchema]]
   [:active-ptql {:optional true} ActivePtqlSchema]
   [:budget {:optional true} BudgetSchema]
   [:conversations {:optional true} [:vector ConversationSchema]]
   [:rename-state {:optional true} [:maybe RenameStateSchema]]
   [:history-search {:optional true} :string]])

;; ---- interceptors ----

(def event-interceptors
  (if ^boolean goog.DEBUG [(rf-common/mk-state-validator [:project-assistant] ProjectAssistantSchema)] []))
